import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { axios } from 'api'
import { ContentModal, Button } from 'ui/acro'
import styled from 'styled-components'
import { useModal_deprecated } from 'hooks'
import { useUserContext } from 'context'
import { maskEmail } from '../allFreeUtils'

const ModalTitle = styled.div`
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -1.2px;
  text-transform: uppercase;
  @media (max-width: 600px) {
    font-size: 28px;
    line-height: 135%;
    letter-spacing: -0.84px;
  }
`

const AmountText = styled.span`
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
`

const AmountValue = styled.span`
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
`

const Description = styled.p`
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.396px;
  display: block;
  margin: 32px 0;
  @media (max-width: 600px) {
    font-size: 16px;
    letter-spacing: 0.352px;
  }
`
const ContinueButton = styled(Button)`
  font-family: Proxima-nova;
  color: #fff;
  width: 100%;
  max-width: 405px;
  background: #000;
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  padding: 12px 32px;
  border-radius: 0;

  @media (max-width: 600px) {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.8px;
    padding: 12px 16px;
  }
`

const Wrapper = styled.div`
  padding: 104px 48px;
  text-align: center;
  @media (max-width: 600px) {
    padding: 64px 16px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

const RefundConfirmation = () => {
  const alertModal = useModal_deprecated()
  const [responseData, setResponseData] = useState({})
  const { user } = useUserContext()

  const handleClick = () => {
    window.history.pushState({}, '', '/')
    alertModal.close()
  }

  const gCStatus = async () => {
    try {
      const { data } = await axios.get('/all-free/refund_gc_selection_status')
      if (['processed', 'pending'].includes(data?.status)) {
        const amount = data?.amount
        if (Number(amount) > 0) {
          setResponseData({ amount, selectionType: data?.selectionType })
          alertModal.open()
        }
      }
    } catch (e) {
      console.log('Error while feting gift card eligibility', e)
    }
  }

  useEffect(() => {
    gCStatus()
  }, [])

  return (
    <ContentModal
      useModal={alertModal}
      overflow='hidden'
      style={{ maxWidth: '862px', borderRadius: 6, border: 'none' }}
    >
      <Wrapper>
        <ModalTitle>
          {responseData?.selectionType === 'gift_card'
            ? 'Alo Gift Voucher sent'
            : 'Refund initiated'}
        </ModalTitle>
        <AmountText>
          {responseData?.selectionType === 'gift_card'
            ? 'Gift Voucher Amount:'
            : 'Refund Amount:'}
        </AmountText>
        <AmountValue> ${responseData?.amount?.toFixed(2)}</AmountValue>
        <Description>
          <div>Thank you!</div>
          {responseData?.selectionType === 'gift_card'
            ? `Your digital gift voucher will be emailed to you at ${maskEmail(
                user?.email
              )} within 24 hours. `
            : `Your refund is processing and will be issued to your original payment method within 7-10 business days, depending on your bank.`}
        </Description>

        <ButtonContainer>
          <ContinueButton onClick={handleClick}>
            Continue to Alo wellness Club
          </ContinueButton>
        </ButtonContainer>
      </Wrapper>
    </ContentModal>
  )
}

RefundConfirmation.propTypes = {
  useModal: PropTypes.object.isRequired
}

export default RefundConfirmation
